export const openModal = (modalType, modalProps) => dispatch => {
  dispatch({type: 'OPEN_MODAL', modalType: modalType, modalProps: modalProps})
};

export const closeModal = () => dispatch => {
  dispatch({type: 'CLOSE_MODAL'})
};